// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"Nav_navContainer__3p2bH","searchContainer":"Nav_searchContainer__YzT9b","controlsContainer":"Nav_controlsContainer__XyTPW","dropdown":"Nav_dropdown__2BXse"};